"use client";

import { Pagination as MuiPagination } from "@mui/material";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useWindowSize } from "react-use";

const itemsPerPage = 10;

export const Pagination = ({ allDataCount }: { allDataCount: number }) => {
  const { width } = useWindowSize();

  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { replace } = useRouter();
  const pageFromUrl = Number(searchParams?.get("page") ?? "1");
  const pageCount = Math.max(1, Math.ceil(allDataCount / itemsPerPage));
  const page =
    Number.isInteger(pageFromUrl) && pageFromUrl > 0
      ? Math.min(pageFromUrl, pageCount)
      : 1;

  const handleChange = (_event: React.ChangeEvent<unknown>, value: number) => {
    const params = new URLSearchParams(searchParams);
    if (value > 1) {
      params.set("page", value.toString());
    } else {
      params.delete("page");
    }

    const query = params.toString();
    replace(query ? `${pathname}?${query}` : pathname);
  };

  return (
    <MuiPagination
      count={pageCount}
      page={page}
      onChange={handleChange}
      size={width > 786 ? "medium" : "small"}
    />
  );
};
